import {
  ReportOptions,
  WarningOptions,
} from '@/services/networkReport/models/reportOptions'

export const defaultOptions: ReportOptions = {
  statistics: false,
  hashtags: false,
  warnings: {
    nodesWithoutOptimalState: true,
    noisyMaxNodesWithHugeLeak: true,
    noisyNodesWhereParentStateHasMinimalEffect: true,
    distinguishedStateMismatch: true,
    optimalStateHasABadImpactAllNodePairs: false,
    optimalStateHasABadImpactParentChildrenPairs: true,
    requirementExistsButNoCommonCause: true,
    nearestObservableFaultPairsMissing: true,
    nodesWithoutAssumption: true,
    nodesWithBasePopulationMissingAssumptionSet: true,
    duplicateBasePopulationAssumptionSets: true,
    defaultRequirements: true,
    effectHasHigherProbabilityThanCauses: true,
    allStatesOfCauseVariableHaveTheSameDirectionChange: false,
    WCHGAndPCHGWarnings: true,
    tooSmallImpactOfCauses: true,
  },
}

export const WARNING_LABELS: Record<keyof WarningOptions, string> = {
  nodesWithoutOptimalState: 'Nodes Without Optimal State',
  noisyMaxNodesWithHugeLeak: 'Noisy Max Nodes With Huge Leak',
  noisyNodesWhereParentStateHasMinimalEffect:
    'Noisy Nodes Where Parent State Has Minimal Effect',
  distinguishedStateMismatch: 'Distinguished State Mismatch',
  optimalStateHasABadImpactAllNodePairs:
    'Optimal State Has A Bad Impact All Node Pairs',
  optimalStateHasABadImpactParentChildrenPairs:
    'Optimal State Has A Bad Impact Parent Children Pairs',
  requirementExistsButNoCommonCause: 'Requirement Exists But No Common Cause',
  nearestObservableFaultPairsMissing: 'Nearest Observable Fault Pairs Missing',
  nodesWithoutAssumption: 'Nodes Without Assumption',
  nodesWithBasePopulationMissingAssumptionSet:
    'Nodes With Base Population Missing Assumption Set',
  duplicateBasePopulationAssumptionSets:
    'Duplicate Base Population Assumption Sets',
  defaultRequirements: 'Default Requirements',
  effectHasHigherProbabilityThanCauses:
    'Effect Has Higher Probability Than Causes',
  allStatesOfCauseVariableHaveTheSameDirectionChange:
    'All States Of Cause Variable Have The Same Direction Change',
  WCHGAndPCHGWarnings: 'WCHG And PCHG Warnings',
  tooSmallImpactOfCauses: 'Too small impact of causes',
}

export const IMPACT_DIRECTION_OPTIONS: Array<keyof WarningOptions> = [
  'optimalStateHasABadImpactAllNodePairs',
  'optimalStateHasABadImpactParentChildrenPairs',
  'allStatesOfCauseVariableHaveTheSameDirectionChange',
  'WCHGAndPCHGWarnings',
] as const

export const ASSUMPTION_SET_DEFINITION_OPTIONS: Array<keyof WarningOptions> = [
  'requirementExistsButNoCommonCause',
  'nearestObservableFaultPairsMissing',
  'nodesWithoutAssumption',
  'nodesWithBasePopulationMissingAssumptionSet',
  'duplicateBasePopulationAssumptionSets',
  'defaultRequirements',
] as const
